import Vue from 'vue'
import App from './App.vue'
import ajax from './util/request'
import dataV from '@jiaminghi/data-view'

Vue.prototype.$ajax = ajax;

Vue.config.productionTip = false
Vue.use(dataV)


new Vue({
  render: h => h(App),
}).$mount('#app')
